<template>
    <div class="searchbox" :class="{focussed: focus}">
        <input @focus="onFocus" ref="input" @blur="onBlur" @keydown="onKeyDown" v-model="searchText"
        :placeholder="$t('searchBox.placeholder')" role="searchbox" :aria-label="$t('searchBox.ariaLabel')">
        <font-awesome-icon icon="search" @click="onClick"></font-awesome-icon>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'searchBox',
  components: { FontAwesomeIcon },
  data: function() {
    return {
      focus: false,
      searchText: ''
    };
  },
  methods: {
    onFocus() {
      this.focus = true;
      this.origSearchText = this.searchText;
      this.$emit('focus', true);
    },
    onBlur() {
      this.focus = false;
      this.$emit('focus', false);
    },
    onKeyDown(e) {
      console.log('search keydown', e);
      if (e.key === 'Escape') {
        if (this.searchText === '') {
          if (this.origSearchText !== '') {
            this.onClick();
          }
          this.$refs.input.blur();
        } else {
          this.searchText = '';
        }
      } else if (e.key === 'Enter') {
        this.onClick();
        this.$refs.input.blur();
      }
      e.stopPropagation();
    },
    onClick() {
      this.$emit('search', this.searchText);
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .searchbox {
        display: inline-block;
        float: right;
        border: $search-border;
        border-radius: 5px;
        padding: 5px 5px;
        margin: 5px 20px;
        background-color: $gray-200;
        transition: width 0.5s, background-color 0.5s;
        width: 100px;
        &.focussed {
            box-shadow: $search-focusshadow;
            background-color: white;
            width: calc(100% - 40px);
        }
        input {
            width: calc(100% - 30px);
            outline: none;
            border: none;
            background-color: transparent;
            margin-right: 10px;
        }

    }

</style>
